export const ImageContainer = {
  Mobile: 'mobile',
  GP: 'gp-info-cards',
  svg: 'svg',
  png: 'png',
} as const;
export type ImageContainer = (typeof ImageContainer)[keyof typeof ImageContainer];
